import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Grid,
  InputLabel,
  TextField,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemText,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

// Contexts
import DiscountContext from "../../../../context/discounts/DiscountContext";
import StoreContext from "../../../../context/stores/StoreContext";

const useStyles = makeStyles((theme) => ({
  field: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
  list: {
    width: "100%",
    height: 330,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    border: "1px solid silver",
    borderRadius: "5px",
    marginBottom: "0.5rem",
  },
  listItem: {
    backgroundColor: "inherit",
  },
  includedList: {
    maxHeight: 400,
    paddingLeft: 20,
    overflow: "auto",
  },
}));

const StoresInclude = () => {
  const classes = useStyles();

  const {
    selected_discount,
    form_data,
    form_error,
    setFormData,
    setFormError,
  } = useContext(DiscountContext);
  const {
    stores_searched,
    searchStores,
    clearSearchStores,
    activeStores,
    getActiveStores,
  } = useContext(StoreContext);

  const searchText = useRef("");
  const [button, setButton] = useState({
    name: "Select All Stores",
    action: "all active",
  });

  const changeButtonAction = (data) => {
    // Change Button Action - Select / Deselect All Active Stores
    if (activeStores && activeStores.length > 0) {
      if (activeStores.length === data.discount_include.length) {
        setButton({
          name: `Deselect All Stores (${data.discount_include.length})`,
          action: "deselect",
        });
      } else {
        setButton({
          name: "Select All Stores",
          action: "all active",
        });
      }
    }
  };

  const onChange = () => {
    if (searchText.current.value) {
      searchText.current.value = searchText.current.value
        .toLowerCase()
        .replace(/ /g, "");
    } else {
      // No Search Text - Clear Searched Stores & Change Button Action
      clearSearchStores();
      changeButtonAction(form_data);
    }
  };

  const onSearch = (e) => {
    e.preventDefault();

    if (searchText.current.value) {
      searchStores(searchText.current.value);
    }
  };

  const handleStore = (action, store_name) => {
    if (action === "deselect") form_data["discount_include"] = [];

    if (action === "all active") {
      form_data["discount_include"] = activeStores.map(
        (each) => each.store_name
      );
    }

    if (action === "add") {
      if (!form_data["discount_include"].includes(store_name)) {
        form_data["discount_include"].push(store_name);
      }
    }

    if (action === "remove") {
      const index = form_data["discount_include"].indexOf(store_name);
      if (index !== -1) {
        form_data["discount_include"].splice(index, 1);
      }
    }

    // Change Button Action
    changeButtonAction(form_data);

    // Error Checking
    if (form_data["discount_include"].length < 1) {
      form_error["discount_include"] = "Select at least ONE store!";
    } else {
      form_error["discount_include"] = "";
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  useEffect(() => {
    // onLoad - Reset Search Bar Value
    searchText.current.value = "";
  }, [selected_discount]);

  useEffect(() => {
    // Call Function - Select All Active Stores
    if (activeStores && activeStores.length > 0) {
      handleStore(button.action);
    }
  }, [activeStores]);

  return (
    <Grid item xs={12} className={classes.field}>
      <Grid item>
        <InputLabel shrink required>
          Store Included{" "}
        </InputLabel>{" "}
      </Grid>
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {/* Search Store */}{" "}
        <Grid item xs={4} container justifyContent="flex-start" align="center">
          <Grid item xs={12}>
            <form onSubmit={onSearch}>
              <Grid item xs={12} container justifyContent="flex-start" align="center">
                <Grid item xs>
                  <TextField
                    fullWidth
                    size="small"
                    margin="dense"
                    variant="outlined"
                    id="search_store"
                    name="search_store"
                    placeholder="Search store"
                    inputRef={searchText}
                    onChange={onChange}
                    style={{
                      margin: 0,
                    }}
                  />{" "}
                </Grid>{" "}
                <Grid item xs={2}>
                  <IconButton
                    type="submit"
                    className={classes.button}
                    style={{
                      padding: 10,
                    }}
                  >
                    <SearchIcon fontSize="small" />
                  </IconButton>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </form>{" "}
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="outlined"
              onClick={() => {
                if (button.action === "all active") getActiveStores();
                else handleStore(button.action);
              }}
              className={classes.button}
              style={{
                margin: "5px 0",
              }}
            >
              {button.name}{" "}
            </Button>{" "}
          </Grid>
          <Grid item xs={12}>
            <List dense className={classes.list}>
              {" "}
              {stores_searched.map((store, index) => (
                <ListItem
                  key={index}
                  className={classes.listItem}
                  button
                  onClick={() => handleStore("add", store)}
                >
                  <ListItemText secondary={store} />{" "}
                </ListItem>
              ))}{" "}
            </List>{" "}
          </Grid>{" "}
        </Grid>
        {/* Store Included */}{" "}
        <Grid
          item
          xs={8}
          container
          spacing={1}
          className={classes.includedList}
        >
          <Grid item xs={12}>
            <FormHelperText error>
              {" "}
              {form_error.discount_include
                ? form_error.discount_include
                : form_data.discount_include.length > 0 && (
                    <span>
                      * Click To Remove Store Included <br /> * Scroll Down For
                      More Store Included{" "}
                    </span>
                  )}{" "}
            </FormHelperText>{" "}
          </Grid>{" "}
          {form_data.discount_include.map((store, index) => (
            <Grid item key={index}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={() => handleStore("remove", store)}
              >
                {store}{" "}
              </Button>{" "}
            </Grid>
          ))}{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default StoresInclude;
